import { useQuery } from '@tanstack/react-query';

import { Declarant } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { useUser } from '@hooks/user/useUser';
import { apiClient } from '@utils';

export const useDeclarant = () => {
  const { data: user } = useUser();

  const id = (user?.declarant as unknown as Declarant)?._id;

  return useQuery({
    queryKey: ['declarant', id],
    staleTime: 10 * 60 * 1000,
    queryFn: async (): Promise<Declarant> => {
      try {
        const result = await apiClient.declarant.getDeclarantById.query({ params: { id } });
        if (result.status !== 200) throw result.body;

        const data = result.body.data as Declarant;

        if (typeof data?.company?.idCard?.expirationDate === 'string') {
          data.company.idCard.expirationDate = new Date(data.company.idCard.expirationDate);
        }

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declarant details');
      }
    },
    placeholderData: {} as unknown as Declarant,
    enabled: !!id,
  });
};
